import React, { ReactElement } from 'react'
import { Flex } from 'theme-ui'
import { Svg } from 'ui'
import ComprehensiveAnalyticsIcon from 'images/organization/features/analytics/comprehensive-analytics.svg'
import ComprehensiveAnalyticsBg from 'images/organization/features/malware/protection-bg.svg'
import TrafficMonitoringIllustration from 'images/organization/features/analytics/traffic-monitoring.png'
import ReportsIllustration from 'images/organization/features/analytics/reports.png'
import DataAnalysisIllustration from 'images/organization/features/analytics/data-analysis.png'
import { TextWithBreakpointVariant } from 'ui/TextWithBreakpointVariant'
import CommonSectionItem from 'components/Organization/LandingPageCommonComponents/CommonSectionItem'

export default function ComprehensiveAnalytics(): ReactElement {
  return (
    <Flex
      sx={{
        width: '100%',
        flexDirection: 'column',
        gap: ['4.2rem', '4.8rem'],
        justifyContent: 'center',
        textAlign: 'center',
        px: '1.6rem',
      }}
    >
      <Flex
        sx={{ position: 'relative', flexDirection: 'column', gap: '1.6rem', alignItems: 'center' }}
      >
        <Svg
          svg={ComprehensiveAnalyticsIcon}
          descriptiveText="Comprehensive analytics section icon"
        />
        <TextWithBreakpointVariant
          variant={['size24Weight600', 'size40Weight600']}
          sx={{ color: 'white', mt: '-4rem', zIndex: 'zIndex1' }}
        >
          Comprehensive analytics tooling
        </TextWithBreakpointVariant>
        <Svg
          svg={ComprehensiveAnalyticsBg}
          sx={{ position: 'absolute', top: '-5rem', width: ['70rem', 'auto'], zIndex: 'zIndex0' }}
          descriptiveText="Decorative background pattern"
        />
      </Flex>
      <Flex
        sx={{ flexDirection: 'column', gap: '6.4rem', alignItems: 'center', zIndex: 'zIndex2' }}
      >
        <CommonSectionItem
          image={TrafficMonitoringIllustration}
          title="Real-time traffic monitoring"
          description="Monitor DNS requests and network activity in real-time. This feature provides complete
           visibility into how your network is being used, enabling you to detect unusual behavior instantly and keep your business secure."
        />
        <CommonSectionItem
          isReverse
          image={ReportsIllustration}
          title="Customizable reports"
          description="Create and customize reports to suit your organization's needs with configurable granularity and regularity.
           Whether it's monthly summaries or specific domain access logs, Control D's reporting tools help you stay informed."
        />
        <CommonSectionItem
          image={DataAnalysisIllustration}
          title="Historical data analysis"
          description="Analyze historical DNS data to identify long-term trends and understand network usage patterns.
           This helps in making informed decisions to improve security and optimize network resources."
        />
      </Flex>
    </Flex>
  )
}
